export default function PendingVC() {
  return <div>Pending VC content goes here.</div>;
}